import {
  SET_CACHED_DATA_TO_STORE,
  CLEAR_CACHED_DATA,
} from '../actions';

interface CachingState {
  [key: string]: unknown;
}

interface Action {
  type: string;
  payload?: Record<string, unknown>;
}

const initialState: CachingState = {};

export const caching = (state: CachingState = initialState, { type, payload }: Action): CachingState => {
  switch (type) {
    case SET_CACHED_DATA_TO_STORE:
      return {
        ...state,
        ...payload,
      };

    case CLEAR_CACHED_DATA:
      return {};

    default:
      return state;
  }
};
